import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import AuthContextSchema, { AuthContextJSON, AuthContextParams } from "users/auth/context/auth-context-schema";

export class AuthContext {
  public static readonly EXAMPLE: AuthContext = AuthContext.create({
    viewingAsVendor: true,
  });

  public static create(values: AuthContextParams): AuthContext {
    const parsed = AuthContextSchema.validate(values);
    if (isNullOrUndefined(parsed)) {
      throw new Error("Invalid AuthContext parameters.");
    }
    return new AuthContext(parsed);
  }

  public static fromJSON(json: AuthContextJSON): AuthContext {
    if (isNullOrUndefined(json)) return json;
    const params = AuthContextSchema.deserialize(json);
    return new AuthContext(params);
  }

  public readonly viewingAsVendor?: boolean;

  public constructor(params: AuthContextParams) {
    this.viewingAsVendor = params.viewingAsVendor;
  }

  public toJSON(): AuthContextJSON {
    return AuthContextSchema.serialize(this);
  }

  public isEqualTo(other: AuthContext): boolean {
    return this.viewingAsVendor === other.viewingAsVendor;
  }

  public toString(): string {
    return `AuthContext { 
      viewingAsVendor: ${this.viewingAsVendor}
    }`;
  }
}
